export const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
        return "Enter Email";
    }
    if (!emailRegex.test(email)) {
        return "Enter a valid email address";
    }
    return null; // Valid email
}

export const validatePassword = (password) => {
    if (password.length < 6) {
        return "Password must be at least 6 characters";
    }
    if (!/[a-zA-Z]/.test(password)) {
        return "Password must contain at least one letter";
    }
    if (!/[0-9]/.test(password)) {
        return "Password must contain at least one number";
    }
    if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) {
        return "Password must contain at least one special character";
    }
    return null; // Valid password
}

// Store fields: allow only numeric, alphabets, space, @, comma, -, _
// (keep regex here so it can be reused anywhere)
export const INPUT_SANITIZE_REGEX = /[^a-zA-Z0-9._-\s]/g;

export const sanitizeStoreInput = (value = "") => {
    return String(value)
        .replace(INPUT_SANITIZE_REGEX, "")
        .replace(/\s{2,}/g, " ")
        .replace(/^\s+/, "");
};